import Card from "../common/Card";

const toneClasses = {
  indigo: "border-l-indigo-500 dark:border-l-indigo-400",
  emerald: "border-l-emerald-500 dark:border-l-emerald-400",
  blue: "border-l-blue-500 dark:border-l-blue-400",
  rose: "border-l-rose-500 dark:border-l-rose-400",
  amber: "border-l-amber-500 dark:border-l-amber-400",
  violet: "border-l-violet-500 dark:border-l-violet-400",
};

const SummaryCard = ({
  label,
  value,
  helperText = "",
  tone = "indigo",
  className = "",
  compact = false,
}) => {
  return (
    <Card
      className={["h-full min-h-[88px] border-slate-200/70 bg-white/95 p-4 shadow-sm shadow-slate-200/40 ring-1 ring-slate-100/50 dark:border-slate-700 dark:bg-slate-950/70", toneClasses[tone] || toneClasses.indigo, compact ? "min-h-[48px] px-3 py-2" : "", className]
        .filter(Boolean)
        .join(" ")}
    >
      <div className={["flex h-full flex-col items-start justify-start text-left", compact ? "gap-0" : "gap-1"].join(" ")}>
        <p
          className={[
            "max-w-full font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400",
            compact ? "text-[9px] sm:text-[10px]" : "text-[11px] sm:text-[12px]",
          ].join(" ")}
        >
          <span>{label}</span>
          {helperText ? (
            <span className="ml-1 text-[9px] font-medium normal-case tracking-normal text-slate-400 dark:text-slate-500">
              ({helperText})
            </span>
          ) : null}
        </p>
        <div className={["flex w-full items-start", compact ? "min-h-[1.15rem]" : "min-h-[2.75rem]"].join(" ")}>
          <div
            className={[
              "w-full break-words font-semibold leading-snug tracking-tight text-slate-900 dark:text-slate-100",
              compact ? "text-[13px] sm:text-[14px]" : "text-[16px] sm:text-[18px]",
            ].join(" ")}
          >
            {value}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SummaryCard;
